import { BillingStrategy } from '@galaxy/billing';

export function strategyForDisplay(s: BillingStrategy): string {
  switch (s) {
    case BillingStrategy.EndOfPeriod:
      return 'End of Period';
    case BillingStrategy.StartOfPeriod:
      return 'Start of Period';
    case BillingStrategy.Instantly:
      return 'Instantly';
    case BillingStrategy.EndOfDay:
      return 'End of Day';
    default:
      return 'N/A';
  }
}
